import { InvalidUrlError } from '@execonline-inc/url';
import { AppyError } from '../../../Appy';
import { MissingLinkError } from '../../../LinkyLinky';

interface Loading {
  kind: 'loading';
}

interface Ready {
  kind: 'ready';
  total: number;
}

interface Unavailable {
  kind: 'unavailable';
}

export type State = Loading | Ready | Unavailable;

export const loading = (): Loading => ({ kind: 'loading' });

export const ready = (total: number): Ready => ({ kind: 'ready', total });

export const unavailable = (): Unavailable => ({ kind: 'unavailable' });

export type CountError = AppyError | InvalidUrlError | MissingLinkError;
